<script setup lang="ts">
const props = defineProps({
  items: {
    type: Array<{title: string; content: string}>,
    required: true,
  },
});

const currentItem = ref<string>();

const splitItems = computed(() => {
  const first: typeof props.items = [];
  const second: typeof props.items = [];
  props.items.forEach((item, i) => {
    (i % 2 === 0 ? first : second).push(item);
  });
  return [first, second];
});

function onToggle(title: string) {
  currentItem.value = currentItem.value === title ? '' : title;
}
</script>

<template>
  <div class="accordion">
    <div class="flex flex-col gap-4">
      <template v-for="(item, index) in splitItems[0]" :key="item.title">
        <AccordionItem class="accordion-item" :ariaId="item.title" :title="item.title" :open="currentItem === item.title" @toggle="onToggle(item.title)">
          <p v-html="item.content" />
        </AccordionItem>
      </template>
    </div>

    <div class="flex flex-col gap-4">
      <template v-for="(item, index) in splitItems[1]" :key="item.title">
        <AccordionItem class="accordion-item" :ariaId="item.title" :title="item.title" :open="currentItem === item.title" @toggle="onToggle(item.title)">
          <p v-html="item.content" />
        </AccordionItem>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/assets/scss/queries';
.accordion {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
  grid-template-rows: masonry;

  @include queries.for-size(phone) {
    grid-template-columns: 1fr;
  }
}
</style>
